import * as React from "react";

const BlueMark = (props: any) => (
  <svg
    width={108}
    height={168}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M108 57.283V168c-6.196-.807-12.35-2.742-17.975-5.414-23.183-11.021-39.697-33.496-47.048-58.072-2.507-8.418-4.094-17.2-7.98-25.09-4.733-9.589-12.558-17.228-19.617-25.272C8.32 46.11 1.678 36.98.23 26.376-1.217 15.772 4.227 3.554 14.544.66c11.502-3.229 22.864 5.943 29.38 15.947 6.53 10.006 11.027 21.849 20.537 29.085 12.086 9.2 28.544 8.364 43.54 11.592"
      fill="#2D5BFF"
    />
  </svg>
);

export default BlueMark;
